import component from './TakoverWarning.vue'
export default component
